import { get, post, put, del } from '../utils/request';

// Group type enum
export enum GroupType {
  CASE_HANDLING = '办案',
  BACKEND = '后端组',
  AFTER_SALES = '售后',
  DOCUMENT_WRITING = '文书写作',
  CASE_FILING = '立案',
  CASE_MANAGEMENT = '案管',
}

// User group interfaces
export interface UserGroup {
  id: number;
  name: string;
  description?: string;
  group_type: string;
  leader_id?: number;
  leader_name?: string;
  member_count?: number;
  creator_name?: string;
  created_by: number;
  created_at: string;
  updated_at: string;
  deleted_at?: string;
}

export interface UserGroupMember {
  id: number;
  group_id: number;
  user_id: number;
  created_at: string;
  user_name?: string;
  user_email?: string;
  user_role?: string;
}

export interface UserGroupWithMembers extends UserGroup {
  members: UserGroupMember[];
}

export interface UserGroupListRequest {
  skip?: number;
  limit?: number;
  keyword?: string;
}

export interface UserGroupListResponse {
  items: UserGroup[];
  total: number;
  page: number;
  page_size: number;
  pages: number;
}

export interface CreateUserGroupRequest {
  name: string;
  description?: string;
  group_type: string;
  leader_id?: number;
  member_ids?: number[];
}

export interface UpdateUserGroupRequest {
  name?: string;
  description?: string;
  group_type?: string;
  leader_id?: number;
}

export interface AddGroupMembersRequest {
  user_ids: number[];
}

// API methods

// Get all user groups
export const getUserGroups = async (params?: UserGroupListRequest): Promise<UserGroupListResponse> => {
  return get<UserGroupListResponse>('/user-groups/', { params });
};

// Get user group by ID with members
export const getUserGroup = async (groupId: number): Promise<UserGroupWithMembers> => {
  return get<UserGroupWithMembers>(`/user-groups/${groupId}`);
};

// Create new user group
export const createUserGroup = async (data: CreateUserGroupRequest): Promise<UserGroup> => {
  return post<UserGroup>('/user-groups/', data);
};

// Update user group
export const updateUserGroup = async (groupId: number, data: UpdateUserGroupRequest): Promise<UserGroup> => {
  return put<UserGroup>(`/user-groups/${groupId}`, data);
};

// Delete user group
export const deleteUserGroup = async (groupId: number): Promise<void> => {
  return del(`/user-groups/${groupId}`);
};

// Add members to group
export const addGroupMembers = async (groupId: number, data: AddGroupMembersRequest): Promise<UserGroupMember[]> => {
  return post<UserGroupMember[]>(`/user-groups/${groupId}/members`, data);
};

// Remove member from group
export const removeGroupMember = async (groupId: number, userId: number): Promise<void> => {
  return del(`/user-groups/${groupId}/members/${userId}`);
};

// Get user's groups
export const getUserGroupsByUserId = async (userId: number): Promise<UserGroup[]> => {
  return get<UserGroup[]>(`/user-groups/user/${userId}/groups`);
};

// Get my groups
export const getMyGroups = async (): Promise<UserGroup[]> => {
  return get<UserGroup[]>('/user-groups/my/groups');
};